export const getIdFromTitle = (item: { title: string }) =>
  item.title.toLowerCase();
